import { makeStyles } from '@material-ui/core/styles';

const drawerWidth = 175;

const theLayoutStyles = makeStyles((theme) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
    },
    main: {
      flex: true,
      padding: theme.spacing(3),
      [theme.breakpoints.up('sm')]: {
        paddingLeft: drawerWidth+theme.spacing(3),
      },
    },
    footer: {
      padding: theme.spacing(1),
      textAlign: 'center',
      marginTop: 'auto',
      backgroundColor: theme.palette.grey[200]
    },
    footerText: {
        color: theme.palette.black
    },
    title: {
        flexGrow: 1,
        paddingLeft: theme.spacing(2),    
    },
    subtitle: {
        // flex: 0,
        fontWeight: 500,
        marginRight: theme.spacing(3),
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    appBar: {
        position: 'relative',
        [theme.breakpoints.up('sm')]: {
            paddingLeft: drawerWidth,
          },
      },
  }));

  export default theLayoutStyles;